import {getDedup} from "./Debup";


const FacebookPixel = {
  isFbq : typeof fbq === "function",
  ViewCategory: function veiwListing(products){
    if (this.isFbq ) {
      const sku = products.map(item => item.sku);

      fbq('trackCustom', 'ViewCategory', {
        content_ids: sku,
        content_type: 'product',
      });

    }
  },
  viewContent: function veiwProduct () {
    if (this.isFbq && typeof productDetails !== 'undefined') {
      const details = productDetails
      if(getDedup().getValue(`FacebookPixel_ViewContent_${details.id}`)) {
        return;
      }

      getDedup().setValue(`FacebookPixel_ViewContent_${details.id}`, 1);

      fbq('track', 'ViewContent', {
        content_name: details.name,
        content_type: 'product',
        content_category: details.brand || '',
        content_ids: details.id,
        value: details.price,
        currency: 'UAH'
      });
    }
  },
  addToCart: function addEvent ([response]){
    const product = response[1];
    const {sku} = product.options.parent_product;

    if (this.isFbq){
    	if(getDedup().getValue(`FacebookPixel_AddToCart_${sku}`)) {
			return;
		}

		getDedup().setValue(`FacebookPixel_AddToCart_${sku}`, 1);

      fbq('track', 'AddToCart', {
        content_name: product.name,
        content_type: 'product',
        content_ids: sku,
        content_category: product.options.categories || '',
        value: product.price,
        currency: 'UAH'
      });
    }
  },
  getList: function responseList (list,oneClick = false){
    const listObj = {
      categories:[],
      content_ids:[],
      num_items:0,
      value:0,
    }

    if(!oneClick){
      Object.entries(list).forEach(([key, item]) => {
        listObj.categories.push(item.options.categories);
        listObj.content_ids.push(item.options.parent_product.sku || item.options.sku);
        listObj.num_items += 1;
        listObj.value += item.price;
      });
    }else{
      listObj.categories = list[1];
      listObj.content_ids = list[5];
      listObj.num_items = 1;
      listObj.value = list[0].product_price;
    }

    return listObj;
  },
  initiateCheckout: function initCheckout (productList) {
    if (this.isFbq) {
    	if(getDedup().getValue('FacebookPixel_InitiateCheckout')) {
        return;
      }
	  	getDedup().setValue('FacebookPixel_InitiateCheckout', 1);
      const list = this.getList(productList);

      fbq('track', 'InitiateCheckout', {
        value: list.value,
        currency: 'UAH',
        content_type: 'product_group',
        content_name: 'Оформление заказа',
        content_category: list.categories,
        content_ids: list.content_ids,
        num_items: list.num_items,
      });
    }
  },
  purchase: function orderSuccess(cart,orderNumber = null,OneClick = false) {
    if (this.isFbq) {
      const list = this.getList(cart,OneClick);

      if(getDedup().getValue(`FacebookPixel_Purchase_${orderNumber}`)) {
        return;
      }

		  getDedup().setValue(`FacebookPixel_Purchase_${orderNumber}`, 1);

      fbq('track', 'Purchase', {
        value: list.value,
        currency: 'UAH',
        content_name: OneClick? 'Покупка в один клик' :'Оформление заказа',
        content_type: 'product',
        content_ids: list.content_ids,
        num_items: list.num_items,
        content_category: list.categories,
        order_id: orderNumber
      });
    }
  },
  contact: function contactEvent(){
    if (this.isFbq) {
      fbq('track', 'Contact');
    }
  }
}

export default FacebookPixel;
